// i18next initialisation. English only for now, but fully wired so more
// languages can be dropped in as additional resource bundles.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './en';

void i18n.use(initReactI18next).init({
  resources: { en },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
